export default {
      id: "oc-cloudflare-usage",
      viewBox: "0 0 2264 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-cloudflare",
      toString: function () {
        return this.url;
      }
    }